import { type AxiosResponse } from "axios";

import ApiClient from "./ApiClient";

export interface StreamReportBulkRequest {
  ids: number[];
}

export interface StreamReportBulkSuccessResponse {
  success: boolean;
}

class StreamReportService extends ApiClient {
  constructor() {
    super("/stream_reports");
  }

  archive(id: number): Promise<AxiosResponse<StreamReportBulkSuccessResponse>> {
    return this.delete<StreamReportBulkSuccessResponse>(`/${id}`);
  }

  bulkArchive(
    ids: number[]
  ): Promise<AxiosResponse<StreamReportBulkSuccessResponse>> {
    return this.post<StreamReportBulkSuccessResponse>(`/bulk_archive`, {
      params: { ids },
    });
  }

  bulkRegenerate(
    ids: number[]
  ): Promise<AxiosResponse<StreamReportBulkSuccessResponse>> {
    return this.post<StreamReportBulkSuccessResponse>(`/bulk_regenerate`, {
      params: { ids },
    });
  }

  regenerate(
    id: number
  ): Promise<AxiosResponse<StreamReportBulkSuccessResponse>> {
    return this.post<StreamReportBulkSuccessResponse>(`/${id}/regenerate`);
  }
}

export default new StreamReportService();
